import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import TitlePage from 'components/TituloPage';
import Button from 'components/Button';
import { homeContribuinte } from 'routes/paths';
import { changeInput } from 'utils/formUtils';
import { formatterDadosCadastraisCadastro } from 'utils/formatter/dadosCadastrais';
import { submitDadosCadastraisInput, sucessoRequerimento } from '../submitForm';
import { isValidForSubmit } from '../validations';
import FormDadosCadastrais from 'containers/Forms/FormDadosCadastrais';
import * as S from '../styles';
import * as Style from 'components/Style';

export default function PageDadosCadastraisCadastrar() {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const dadosCadastrais = useSelector(state => state.dadosCadastrais.dadosCadastrais);

  const [loadingEnviar, setLoadingEnviar] = React.useState(false);

  const {
    control,
    setValue,
    getValues,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: formatterDadosCadastraisCadastro(user, dadosCadastrais),
  });

  const handleChange = e => {
    changeInput(e, setValue, errors, setError);
  };

  const onSubmit = data => {
    setLoadingEnviar(true);
    dispatch(submitDadosCadastraisInput(data, user))
      .then(respostaApi => sucessoRequerimento(respostaApi, history, dispatch))
      .finally(() => setLoadingEnviar(false));
  };

  const onSendFormulario = () => {
    const values = getValues();
    const isValid = dispatch(isValidForSubmit(values, setError));

    if (isValid) {
      onSubmit(values);
    }
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle={'DADOS CADASTRAIS - CADASTRAR'} backPage={homeContribuinte} />
      <form>
        <Style.GlobalCard>
          <FormDadosCadastrais
            control={control}
            onChange={handleChange}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            setError={setError}
          />
        </Style.GlobalCard>
        <S.ContainButton>
          <Button
            text={'Enviar'}
            clickAction={onSendFormulario}
            css={{ margin: '7px 0px 7px auto' }}
            loading={loadingEnviar}
          />
        </S.ContainButton>
      </form>
    </S.Contain>
  );
}
